export default "__VITE_ASSET__6BriudcX__"